import { FormSection } from '@/containers/forms/FormSection'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { Button, Flex, Stack } from '@chakra-ui/react'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { BaseContainerProps } from '.'
import { InsureesForm } from '../forms/InsureesForm'


type InsureesProps = {
  onContinue: () => Promise<any>
} & BaseContainerProps

export const Insurees = ({ onContinue, ...props }: InsureesProps) => {
  const { formState: { isSubmitting } } = useFormContext<InsuranceParamsTravelDto>()
  const { isDisabled } = useInsuranceParams()

  return (
    <FormSection {...props}
      footer={isDisabled ? undefined :
        <Stack direction='column' w='100%'>
          <Flex sx={{ w: '100%', justifyContent: 'center' }}>
            <Button
              type="button"
              variant="solid"
              isLoading={isSubmitting}
              colorScheme="green"
              onClick={onContinue}
            >
              Pokračovat
            </Button>
          </Flex>
        </Stack>
      }
    >
      <InsureesForm editableBirthdate prefix='travel.insurees' />
    </FormSection>
  )
}
